"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    statusFeedbackVariants: ()=>statusFeedbackVariants
});
const external_tailwind_variants_namespaceObject = require("tailwind-variants");
const statusFeedbackVariants = (0, external_tailwind_variants_namespaceObject.tv)({
    slots: {
        root: 'flex flex-col items-center gap-6',
        iconImageWrapperSlot: 'flex items-center justify-center rounded-full',
        iconSlot: '',
        buttonSlot: '@max-md:w-full @md:flex-row flex flex-col gap-2',
        errorCodeSlot: 'text-primary-10 @md:text-body1 font-bold',
        headingSlot: '@md:text-heading3'
    },
    variants: {
        color: {
            success: {
                iconImageWrapperSlot: 'bg-success-3',
                iconSlot: 'text-success-8'
            },
            caution: {
                iconImageWrapperSlot: 'bg-caution-3',
                iconSlot: 'text-caution-9'
            },
            error: {
                iconImageWrapperSlot: 'bg-error-3',
                iconSlot: 'text-error-8'
            }
        },
        showIcon: {
            true: {
                iconImageWrapperSlot: 'h-18 w-18'
            },
            false: {
                iconImageWrapperSlot: 'bg-primary-3 @sm:h-80 @sm:w-80 h-52 w-52'
            }
        },
        showBackground: {
            false: {
                iconImageWrapperSlot: 'bg-transparent'
            }
        }
    },
    defaultVariants: {
        color: 'success',
        showIcon: true,
        showBackground: true
    }
});
exports.statusFeedbackVariants = __webpack_exports__.statusFeedbackVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "statusFeedbackVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
